export interface RuntimeConfig {
  apiOrigin: string;
  engineOrigin: string;
  accountsOrigin: string;
  workspaceOrigin: string;
}

const injected = window.__TIKVN_CONFIG__ ?? {};

export const runtimeConfig: RuntimeConfig = {
  apiOrigin: injected.apiOrigin ?? import.meta.env.VITE_API_ORIGIN ?? "https://api.tikvn.io",
  engineOrigin: injected.engineOrigin ?? import.meta.env.VITE_ENGINE_ORIGIN ?? "https://engine.tikvn.io",
  accountsOrigin:
    injected.accountsOrigin ?? import.meta.env.VITE_ACCOUNTS_ORIGIN ?? "https://accounts.tikvn.io",
  workspaceOrigin:
    injected.workspaceOrigin ?? import.meta.env.VITE_WORKSPACE_ORIGIN ?? "https://app.tikvn.io",
};
